import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "tags-wrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    title: "选择标签",
    "model-value": $props.show,
    fullscreen: true,
    onClose: _cache[4] || (_cache[4] = $event => _ctx.$emit('update:show', false))
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagsList, i => {
      return _openBlock(), _createBlock(_component_el_tag, {
        type: "default",
        key: i.id,
        onClick: $event => $setup.chooseHandler(i)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(i.tagName), 1)]),
        _: 2
      }, 1032, ["onClick"]);
    }), 128))]), _createVNode(_component_el_pagination, {
      background: "",
      "hide-on-single-page": true,
      total: _ctx.total,
      "page-size": _ctx.query.pageSize,
      modelValue: _ctx.query.pageNo,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.query.pageNo = $event),
      onCurrentChange: _cache[1] || (_cache[1] = v => _ctx.query.pageNo = v),
      onPrevClick: _cache[2] || (_cache[2] = v => _ctx.query.pageNo = v),
      onNextClick: _cache[3] || (_cache[3] = v => _ctx.query.pageNo = v)
    }, null, 8, ["total", "page-size", "modelValue"])]),
    _: 1
  }, 8, ["model-value"]);
}